var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnEpubUpload = function SvgIcnEpubUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 11.6673V33.334C33.3337 34.218 32.9825 35.0658 32.3573 35.691C31.7322 36.3161 30.8843 36.6673 30.0003 36.6673H10.0003C9.11628 36.6673 8.26843 36.3161 7.64329 35.691C7.01818 35.0658 6.66699 34.218 6.66699 33.334V6.66732C6.66699 5.78327 7.01818 4.93537 7.64329 4.31023C8.26843 3.68512 9.11628 3.33398 10.0003 3.33398H25.0003L33.3337 11.6673Z",
    fill: "#EDEDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 11.6673H33.3333L25 3.33398V10.0007C25 10.4427 25.1757 10.8666 25.4882 11.1791C25.8007 11.4917 26.2247 11.6673 26.6667 11.6673Z",
    fill: "#DDDEE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 15.3223C20.3746 15.3223 20.6784 15.6261 20.6784 16.0008V28.0008C20.6784 28.3756 20.3746 28.6794 19.9999 28.6794C19.6251 28.6794 19.3213 28.3756 19.3213 28.0008V16.0008C19.3213 15.6261 19.6251 15.3223 19.9999 15.3223Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.52 15.521C19.785 15.256 20.2147 15.256 20.4797 15.521L25.4797 20.521C25.7447 20.786 25.7447 21.2157 25.4797 21.4807C25.2147 21.7457 24.785 21.7457 24.52 21.4807L19.9999 16.9605L15.4797 21.4807C15.2147 21.7457 14.785 21.7457 14.52 21.4807C14.255 21.2157 14.255 20.786 14.52 20.521L19.52 15.521Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnEpubUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_epub_upload.8d9ecc80.svg";
export { ForwardRef as ReactComponent };